import React from 'react';
import { ChevronLeft, Trash2, Mail, Calendar, User } from 'lucide-react';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true
  }).format(date);
};

const MessageDetails = ({ message, onClose, onDelete }) => {
  if (!message) return null;

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Header */}
      <div className="border-b border-gray-200 p-4 flex items-center justify-between bg-blue-50">
        <button
          onClick={onClose}
          className="p-2 -ml-2 text-gray-600 hover:bg-blue-100 rounded-full transition-colors"
          aria-label="Go back"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        
        <h2 className="text-lg font-medium text-gray-900">Message Details</h2>
        
        <button
          onClick={onDelete}
          className="p-2 -mr-2 text-gray-600 hover:bg-red-100 hover:text-red-500 rounded-full transition-colors"
          aria-label="Delete message"
        >
          <Trash2 className="h-5 w-5" />
        </button>
      </div>
      
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-6">
        <div className="mb-6 bg-blue-50 rounded-lg p-4">
          <div className="flex items-center mb-2">
            <User className="h-5 w-5 text-blue-600 mr-2" />
            <h3 className="text-lg font-medium text-gray-900">{message.name}</h3>
          </div>
          
          <div className="flex items-center mb-2">
            <Mail className="h-5 w-5 text-blue-600 mr-2" />
            <a href={`mailto:${message.email}`} className="text-blue-600 hover:underline">
              {message.email}
            </a>
          </div>
          
          <div className="flex items-center">
            <Calendar className="h-5 w-5 text-blue-600 mr-2" />
            <span className="text-gray-600 text-sm">{formatDate(message.createdAt)}</span>
          </div>
        </div>
        
        <div className="bg-gray-50 rounded-lg p-4 relative message-bubble">
          <div className="message-text text-gray-800 whitespace-pre-wrap">{message.message}</div>
        </div>
      </div>
      
      {/* Footer */}
      <div className="border-t border-gray-200 p-4 flex justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors mr-2"
        >
          Close
        </button>
        <button
          onClick={onDelete}
          className="px-4 py-2 bg-red-100 text-red-600 rounded-md hover:bg-red-200 transition-colors"
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default MessageDetails;